const CrimeTvShows = [
    {
      id: 1,
      title: "Delhi Crime",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABQ2hZKF1ROW5vKRZcKqVLiBmsQor5b6WlwTuavggaov44QrD3pVkE375DPCq9tVMxfKmMvOit_-zbVgnh7lBX-wdAvNpG2spjA4QlktzMoEIRWOhkmsju9CMbcPQcsHGMVUs.jpg?r=9dc",
    },
    {
      id: 2,
      title: "Dark Desire",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABd7rH9ktX2s1eh4Fa3Q0qFM3fsTXYutG01voTDcNjZziLdi71fAxhc7YghyhccmZXvIeZAmMY_NDS_XXXyr3zIfY8JmIuJ8IQdzdq2mNFg-zCROyVZD4blf20q8AWqcrjfYw.jpg?r=38d",
    },
  
    {
      id: 3,
      title: "Peaky Blinders",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABRw6CELmOFrRGwZUNM86Fy_1ZH08Pk6Ej45l1rm7L6OQtBmjRHEzJP-Sm2kXsBh7zepgYwrAqRWGGO_5CWMCBLtYdYKV5VY3wadRT_7sGbPvU7wuENsrb2v_QR1UwWPdoFtM.jpg?r=a07",
    },
    {
      id: 4,
      title: "Sacred Games",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABQH20ZQnXb_0cxiBtRaoluyyK5YUNSH5XhdtiuDE13VXKpjIBW9MsrSI1zU7HDUxIPfCTt57kyWIMe7rR4oAcznUkHWo4sTYOZRmEH97ThdQuubaQPb2hz71xCrxgXYILiB8.jpg?r=3ed",
    },
  
    {
      id: 5,
      title: "Aranyak",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABfOncOtVny1Mrizyx45gUvA8f3LUEv7rvGyBEQnX3OOJRpOKxZeN3YTd2xkK_TfLwm_FPg5dXNrlr_umTn1SETRVJ8FG1YPz_K-B6NdczThcc097BDOJ_OWjrpZ9npo_Sx8_.jpg?r=3e1",
    },
    {
      id: 6,
      title: "Narcos",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABW42wDyKQgGJzdN2IprFGO9AosaKxYTws4g1vUhZ2hc8LmmZBtt0fyGQ54Jc9UENiBA7uNpmDtMjw4J79D5E83BAbJOv8-8wKCKHG5vBTT92eUqYs6EILUfRWfT_Z2XqWcuw.jpg?r=973",
    },
    {
      id: 7,
      title: "She",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABXRydynT1qct_7p8RDNQXuSRXNlZlfoT34fDyCQIgqgSqSzuBy0dZ6XVI6a2b6rO_WZTFgHGFxbbnk49oApIZ8Xv3JOH3K-33E6jNzEfRKZTydu22Vz8aenwjA7WDmazCmoy.jpg?r=860",
    },
    {
      id: 8,
      title: "Lupin",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABUZTzGA3hO7CZeyiZZfBMjNSVuwsQvo9bhTlc4M_-V_VQCEAq4u87BaT_HWRIBAr_1FV2VggDindBHlFtetsIIKlBNUr6h0kBtdo-Z1ktnAOIpX6rb_cMBCHUd-HIMEm-E6H.jpg?r=c53",
    },
    {
      id: 9,
      title: "Indian Predator",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABesIkYDzzVvm90muTIjeRaFUQgSoEd1Et2CtjIgftvjBz55XB_6Pm8psxDRYZzdDWvHBRxbFemYYRlKO-LMELfadFAgclTum_91JsQp077N7Uq-Nn1-kzwhJW_XMBi47IZ0H.jpg?r=e78",
    },
    {
      id: 10,
      title: "Yeah Kaali Kaali Ankhein",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABX0JslZaArrI5pU56LSas8qJYAkcmy82sv93da_0s67BD0wZMjpC_Hyi0b0j8k_4EmCsiBkKKrRH9X9iy-C7W449QBpDm_H-TptU6AWoWDTYi8BeJdeGrJxjMYR95QMhCuh6.jpg?r=7bc",
    },
    {
      id: 11,
      title: "Titans",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABSAbbGNQmHNMOG-1n6P_teekYy9rth6z5QJnh-r2rMiSMNPfkV_Sv_ZyFpi_5BEjOyaltjj8k1qQIBZHRK5siLG4ef84y2TerPoISwmzE2vxQXWFDS9dKsDdpPUT_kax-QIz.jpg?r=a23",
    },
    {
      id: 12,
      title: "Hellbound",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABYZ-4DlElOZZPYCYRKGhUvUag2PPC25jA7KNLuup-U6jcIasc6cVRE8_EwBKnF0hHkKctHBp_8BDgfx7fJKG8-SkrNW64ERVsiKIFGRzDnTxdLYTWmBJ8WMQbl0_k3lITtEo.jpg?r=02d",
    },
  ];
  
  
  export default CrimeTvShows;
  